import { AffiliateConversionStatus, AffiliateSource } from "@daytrip/legacy-enums";
import { Exclude, Expose } from "class-transformer";
import { IsString, IsUUID, IsDefined, IsEnum } from "class-validator";

import { GField, GInputType, GObjectType } from "../graphql";
import "reflect-metadata";

@GObjectType("AffiliateConversion")
@GInputType("AffiliateConversionInput")
@Exclude()
export class AffiliateConversion {
    @GField()
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public clickId: string;

    @GField(() => AffiliateConversionStatus)
    @IsEnum(AffiliateConversionStatus)
    @IsString()
    @IsDefined()
    @Expose()
    public status: AffiliateConversionStatus;

    @GField(() => AffiliateSource)
    @IsEnum(AffiliateSource)
    @IsString()
    @IsDefined()
    @Expose()
    public source: AffiliateSource;
}
